<template>
	<BuyBase
		:title="getConstants('PRICING_NEW_COMMON_FREE')"
		:actions="getConstants('PRICING_NEW_TAP_USE')"
		@viewDetail="viewDetail"
		class="tap-free"
		type="free"
	>
		<div slot="limit">
			<p>{{ getConstants('PRICING_NEW_TAP_FREE_UPLOAD') }}</p>
			<p>{{ getConstants('PRICING_NEW_TAP_FREE_DOWNLOAD') }}</p>
			<UploadTip
				:text="getConstants('PRICING_NEW_TAP_FREE_LIMIT')"
				:content="getConstants('PRICING_NEW_TAP_FREE_UPLOAD_TIPS')"
			/>
		</div>
	</BuyBase>
</template>
<script>
import BuyBase from './BuyBase'
import UploadTip from './UploadTip.vue'

export default {
	data() {
		return {
			visiable: true,
		}
	},
	props: {
		detailShow: {
			type: [String, Boolean],
		},
	},
	components: {
		BuyBase,
		UploadTip,
	},
	methods: {
		viewDetail() {
			if (this.PageInfo.user_name) {
				location.href = '/'
			} else {
				location.href =
					'/d/signup?next=' +
					encodeURIComponent(location.pathname + location.search) +
					'&signup_pricing=true#from=' +
					encodeURIComponent(location.href)
			}
		},
		mouseenter() {
			// /visible=true
			this.visiable = true
			console.log(this.visiable)
		},
	},
	computed: {
		showTap() {
			return !this.detailShow || this.detailShow === 'free'
		},
	},
}
</script>
<style lang="scss" scoped>
.tap-free {
	margin-top: 42px;
	&::before {
		background: #f1f1f1;
	}
}
</style>
